import styled, { css } from "styled-components/macro";
import { Button, Input, Label} from "reactstrap";
import { Modal } from "reactstrap";

export const SubmitCSRButton = styled(Button)`
    background-color: #4C912D;
    width: 100px;
    height: 28px;
    font-size: 12px;
    margin-bottom: 7px;
    display: flex;
    align-items: center;
    &:hover, :focus {
        background-color: #3d7523; 
        border-color: #3d7523;
        box-shadow: none;
    }
`;
export const CloseButton = styled(Button)`
    background-color: #333333 !important;
    border-radius: 3px !important;
    border-color: #333333 !important;
    width: ${ props => (props.width ? props.width :"90px") };
    height: ${ props => (props.height ? props.height :"29px") };
    font-size: 13px !important;
    font-weight: normal !important;
    margin-left: ${ props => (props.ml ? props.ml :"5px") } !important;
    margin-right: ${ props => (props.mr ? props.mr :"5px") } !important;
    margin-top: ${ props => (props.mt ? props.mt :"5px") } !important;
    margin-bottom: ${ props => (props.mb ? props.mb :"5px") } !important;
    color: #fff !important;
    font-family: Verdana !important;
    text-transform: none !important;
    svg {
        margin-bottom: 2px;
        margin-right: 5px;
    }
`;

export const EditButton = styled(Button)`
    background-color: ${props => (props.primary ? "#2070cf" : "#333333")} !important;
    border-radius: 3px !important;
    border-color: ${props => (props.primary ? "#61ae34" : "#333333")} !important;
    width: ${props => (props.width ? props.width : "90px")};
    height: ${props => (props.height ? props.height : "29px")};
    font-size: 13px !important;
    font-weight: normal !important;
    margin-left: ${props => (props.ml ? props.ml : "15px")} !important;
    margin-right: ${props => (props.mr ? props.mr : "10px")} !important;
    margin-top: ${props => (props.mt ? props.mt : "0px")} !important;
    margin-bottom: ${props => (props.mb ? props.mb : "0px")} !important;
    color: #fff !important;
    font-family: Verdana !important;
    text-transform: none !important;
    ${props => (props.disabled ? css`
            background-color: ${props => (props.primary ? "#9ebd8b" : "#bdbdbd")} !important;
            border-color: ${props => (props.primary ? "#9ebd8b" : "#bdbdbd")} !important;
        ` : null)
    }
`;


export const CorrectAllError = styled.div`
    color: rgb(212, 45, 39);
    font-family: Lato;
    font-style: italic;
    border: 2px solid rgb(212, 45, 39);
    padding: 7px;
    position: absolute;
    right: 15px;
`;

export const CertDetailsTable = styled.table`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
    margin-top: 20px;
    tbody {
        tr {
            td:first-child {
                font-weight: 600;
                width: 200px;
                color: #333333;
            }
            td {
                height: 20px;
            }
        }
    }
`;


export const EditActions = styled.div`
    display: flex;
    #cancel_button, #apply_button {
        height: 29px;
        ${props => (props.isOverwriteModel ? css`width: 165px;` : css`width: 105px;` )}
        color: #fff;
        text-transform: none;
        font-size: 1.1rem;
        font-family: Verdana;
        border-radius: 20px;
        padding: 16px 15px;
        white-space: nowrap !important;
    }
    #cancel_button {
        background-color: #eeeeee;
        margin-right: 20px;
        &:hover {
            background-color: #cccccc;
        }
        color: #181d1f;
    }
    #apply_button {
        background-color: #4c912d;
        &:hover {
            background-color: #467c26;
        }
    }
`;
export const HyperLinkDiv = styled.div`
    cursor: pointer;
    color: #6890c6;
`;
export const ModelBodyDiv = styled.div`
    padding: 10px;
    border-radius:4px;
    div[class*='CorrectAllError'] {
        top: 1px;
    }
`;

export const HeaderTitle = styled.div`
    label {
        font-size: 16px;
        margin-bottom: 0;
        font-weight: 600;
        color: #484848;
        
    }
    #header-title {
        display: block;
        > div {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        svg {
            font-size: 22px;
            cursor: pointer;
        }
    }
        label {
            color: #333;
            font-size: 1.4rem;
            display: flex;
            svg {
                ${props => (props.fileUploadError ? css`color: #c20202; margin-right: 10px;` : "")}
            }
        }
    }
`;

export const StyledRowDiv = styled.div`
    hr {
        border-color: #999;
    }
`;

export const CheckBoxDiv = styled.div`
    display: flex;
    align-items: center;
    margin-left: 7px;
    margin-bottom: 18px;
    margin-top: 18px;
    input {
        position: relative;
        margin: 0;
        margin-right: 6px;
        margin-left: 5px;
    }
    label {
        margin-bottom: 0;
        cursor: pointer;
        font-size: 13px;
        color: #000;
    }
`;

export const FileSelectionDiv = styled.div`
    display: flex;
    align-items: center;
    margin-left: 7px;
    margin-bottom: 15px;
    label {
        margin-bottom: 0;
    }
    .label-name {
        margin-left: 5px;
        margin-right: 5px;
        font-size: 13px;
        color: #000;
    }
    input {
        width: 40%;
        margin-right: 7px;
        margin-left: 10px;
        padding-left: 7px !important;
    }
    #choice-file {
        margin-bottom: 0;
        background: #f4f4f4;
        color: #181d1f;
        width: 88px;
        height: 25px;
        border-radius: 4px;
        border: 1px solid gray;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-left: 3px;
    }
    ${(props) => (props.error ? css`
        .label-name {
            color: #d42d27;
        }
        > input {
            border-color: #d42d27 !important;
            background-color: #fff3f3 !important;
        }` : "")}
`;

export const FileNameInput = styled(Input)`
    height: 30px;
    background: #fafafa;
`;

export const ErrorSectionDiv = styled.div`
    margin-left: ${ props => (props.ml ? props.ml :"15px") };;
    i {
        color: #d42d27;
    }
    label {
        color: #d42d27;
        font-size: 10px;
        font-style: italic;
        font-family: Lato;
        font-weight: bolder;
        position: absolute;
        left: 149px;
        top: 101px;
    }
`;

export const FooterButtons = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 7px;
    button {
        width: 92px;
        background-color: #333;
        font-family: Verdana;
        font-size: 12px;
        margin-right: 10px;
        margin-left: 5px;
        margin-top: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 29px;
    }
    button:hover {
        background-color: #000;
    }
    button.disabled {
        cursor: not-allowed;
    }
    button#cancel {
        margin-left: 6px;
    }
`;

export const FooterButtonStyles = styled.div`
    display: flex;
    #cancel_button, #apply_button {
        height: 29px;
        ${props => (props.isOverwriteModel ? css`width: 165px;` : css`width: 105px;` )}
        color: #fff;
        text-transform: none;
        font-size: 1.1rem;
        font-family: Verdana;
        border-radius: 20px !important;
        padding: 16px 15px;
        white-space: nowrap !important;
    }
    #cancel_button {
        background-color: #eeeeee;
        margin-right: 20px;
        &:hover {
            background-color: #cccccc;
        }
        color: #181d1f;
    }
    #apply_button {
        background-color: #4c912d;
        &:hover {
            background-color: #467c26;
        }
    }
`;

export const TextAreaWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    label {
        padding-left: 14px;
        margin-right: 35px;
        font-size: 13px;
        color: #000;
    }
    textarea {
        color: #495057;
        border-color: #ced4da;
        border-radius: 5px;
        padding: 7px 9px;
    }
`;
export const HubParamModal = styled(Modal)`
    ${props => (props.fileUploadError ? css`max-width: 40%;margin-top: 9%;` : props.isOverwriteModel ? css`max-width: 45%;margin-top: 9%;` : "" )}
    ${props => (props.maxWidth ? css`max-width: ${props.maxWidth} !important;` : "" )}
    ${props => (props.mt ? css`margin-top: ${props.mt};` : "" )}
    > div {
        min-height: 280px;
        ${props => (props.fileUploadError ? css`border: 1px solid #808080; border-top: 7px solid #c20202;` 
        : css`border: 1px solid #808080;`)}
        border-radius: 5px !important;
        padding: 10px;
        ${props => (props.isAlertModel !== "" ? css`min-height: 190px;` : null)}
        
    }
    #alert-content {
        margin-top: 21px;
        font-size: 13px;
        line-height: 1.5;
        margin-bottom: 8px;
    }
    #import-file-error {
        margin-top: 20px;
        margin-left: 5px;
    }
    #import-file-error-message {
        color: #c20202;
        margin-left: 5px;
        margin-top: 10px;
    }
    #model-footer-section {
        justify-content: flex-end;
        #cancel_button {
            ${props => (props.fileUploadError ? css`color: #c20202; border: 1px solid #c20202; width: 115px;` : "")}
        }
    }
    #header-title {
        display: block;
        > div {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        svg {
            font-size: 22px;
            cursor: pointer;
        }
    }
        label {
            color: #333;
            font-size: 1.4rem;
            display: flex;
            svg {
                ${props => (props.fileUploadError ? css`color: #c20202; margin-right: 10px;` : "")}
            }
        }
    }
`;
export const TitleHeaderLabel = styled(Label)`
    margin-left: -14px;
    color: #333;
    font-size: 16px;
    font-weight: bold;
`;
export const TableCellLabel = styled(Label)`
    margin-left: -14px;
    color: #333;
    font-size: 14px;
    font-weight: bold;
`;
export const TableCellLabelinYears = styled(Label)`
    color: #333;
    font-size: 14px;
    margin-left: 10px;
`
export const MiniStyledInput = styled.input`
  width: ${(props) => props.width ? props.width : '350px'};
  height: 28px !important;
  border: 1px solid #a9a9a9 !important;
  border-radius: 5px;
  color: #333;
  padding-left: 5px !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 1rem !important;
  font-family: Verdana;
  &:disabled {
    border-color: #babfc7 !important;
    color: #898989;
    background-color: #fff;
  }
  &:focus,
  :focus-visible {
    outline: none;
  }
  ${(props) => 
    props.type === "number" ? css`
    -moz-appearance: textfield; 
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    ` : ""
  }
  ${(props) =>
    props.error
      ? css`
          border-color: #C31200 !important; background-color: #fbf4f4 !important;
        `
      : ""}
`;

export const FormErrorSectionDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  svg {
    color: #C31200;
    margin-left: 3px;
    font-size: 11px;
    // margin-right: 5px;
    margin-top: 2px;
  }
  > p {
    color: #C31200;
    font-size: 13px;
    margin: 8px -261px 0 0;
    font-weight: 600;
  }
  ${(props) => props.disabled ? css`display : none` : ""}
`;

export const ErrorModal = styled(Modal)`
.modal-content{
    width: 515px;
    border-top: 7px solid #c20202;
}
    > div {
        min-height: 280px;
        border: 1px solid #808080;
        border-radius: 5px !important;
        padding: 10px;
        ${props => (props.isAlertModel !== "" ? css`min-height: 100px; min-width: 30px` : null)}
    }
   
    #header-title {
        display: block;
        > div {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        svg {
            font-size: 22px;
            cursor: pointer;
        }
    }
        label {
            color: #c20202;
            font-size: 1.4rem;
            display: flex;
        }

        span {
            color: #333;
            margin-left: 10px;
        }
    }
`;

export const SpinnerContainer = styled.div`
    position: absolute;
    width: ${(props) => (props.width ? props.width : "85%")};
    height: ${(props) => (props.height ? props.height : "79vh")};
    top: ${(props) => (props.top ? props.top : "13%")};
    ${(props) => (props.left ? css`left: ${props.left};` : "")}
    z-index: 9999;
`;
